{
    "introduction": {
        "title": "こんにちは、Cephableです。",
        "back": "はじめに戻る",
        "description": "私はあなたのパーソナルAIです。使い慣れたツールを使って、あらゆる接続環境における制御、作成、自動化をサポートします。私についていくつか知っておくべきことがあります。",
        "action": "さあ、始めましょう！",
        "recording": {
            "title": "音声とビデオはローカルのままです。",
            "description": "あなたの音声や動画を録音、ストリーミング、クラウドに送信することは一切ありません。すべての入力はデバイス上で処理され、プライバシーとセキュリティが確保されます。"
        },
        "data": {
            "title": "あなたのデータはあなたのものです。",
            "description": "あなたのコマンドやアクティビティを、他のユーザーのモデル学習に利用することはありません。すべてはプライベートに保たれ、アプリのコントロールは接続間でも共有されます。"
        },
        "offline": {
            "title": "他のツールが機能しないときにも機能します。",
            "description": "コンテンツ生成、リライト、翻訳、ディクテーションといったインテリジェントなタスクはすべてローカルで実行されます。クラウドは不要です。つまり、オフラインでも作業が可能で、データがデバイスから外部に漏れることはありません。"
        },
        "empower": {
            "title": "搾取するためではなく、力を与えるために構築されました。",
            "description": "私はあなたのコントロールを強化するために設計されています。監視するためではありません。侵入的な追跡や不気味なデータ収集は一切ありません。あなたにとって使いやすい入力だけを。"
        }
    },
    "my-capabilities": {
        "title": "完璧です！私がお手伝いできることは次のとおりです。",
        "back": "機能に戻る",
        "actionTitle": "私のアクションをご覧ください",
        "description": "あなたの興味に基づいて、ワークフローに最も関連のある機能と機能を紹介します。",
        "action": {
            "title": "私のアクションをご覧ください",
            "description": "日々の業務で私がどのようにサポートできるか、いくつかの例をご覧ください。"
        }
    },
    "see-me": {
        "title": "私があなたのような他の人達をどのように助けてきたか知りたいですか?",
        "back": "ユースケースに戻る",
        "description": "さまざまな業界や役割にわたってワークフローをどのように変革したか、実際の例をいくつかご覧ください。"
    },
    "complete": {
        "title": "私を使い始める準備はできましたか?",
        "description": "私の実力、ご覧いただけましたでしょうか？さあ、設定をして、ワークフローの変革を始めましょう。最後まで全力でサポートいたします。",
        "action": "セットアップを完了してCephableの使用を開始する"
    },
    "apps": {
        "title": "すでに愛用されているツールをサポートします",
        "description": "200以上のアプリケーションを事前設定済みでサポート。毎日使用するソフトウェアをそのまま使用できます。設定は不要です。",
        "note": "お使いのアプリが見つからない場合でも、問題ありません。コントロールを生成したり、お客様に最適なカスタムワークフローの作成をお手伝いします。",
        "andMore": "その他"
    },
    "actions": {
        "ctaTry": "今すぐ試す",
        "ctaWatch": "デモを見る",
        "apps": "適合するもの:",
        "abilities": "使用した能力:"
    },
    "interests": {
        "title": "何をお手伝いしましょうか？",
        "back": "興味に戻る",
        "description": "デスクトップや接続されたデバイス上のアプリを操作できます。エクスペリエンスをカスタマイズしましょう。特にご興味のある分野は何ですか？",
        "note": "該当するものをすべて選択すると、ワークフローに最も関連性の高い機能と例が表示されます。",
        "action": "{{count}}件の興味を継続",
        "empty": "少なくとも 1 つの興味を選択してください。",
        "create_design": {
            "label": "作成とデザイン",
            "shortLabel": "デザイン",
            "description": "アーティスト、マーケティング担当者、コンテンツクリエイター向け。"
        },
        "analyze_report": {
            "label": "分析とレポート",
            "shortLabel": "分析する",
            "description": "アナリスト、研究者、ビジネスプロフェッショナル向け。"
        },
        "communicate_collaborate": {
            "label": "コミュニケーションとコラボレーション",
            "shortLabel": "通信する",
            "description": "販売者、会議、リモート チーム向け。"
        },
        "build_develop": {
            "label": "構築と開発",
            "shortLabel": "開発する",
            "description": "開発者、エンジニア、技術専門家向け。"
        },
        "game_play": {
            "label": "ゲームとプレイ",
            "shortLabel": "ゲーム",
            "description": "ゲーマー、ストリーマー、メディア コントロール向け。"
        },
        "learn_teach": {
            "label": "学ぶ＆教える",
            "shortLabel": "学ぶ",
            "description": "教育者、学生、指導員向け。"
        },
        "manage_organize": {
            "label": "管理と整理",
            "shortLabel": "組織化",
            "description": "プロジェクト マネージャー、コーディネーター、オーガナイザー向け。"
        },
        "adapt_access": {
            "label": "適応とアクセス",
            "shortLabel": "アクセシビリティ",
            "description": "適応型コントロールとパーソナライズされたアクセシビリティのニーズに対応します。"
        },
        "everything": {
            "label": "あらゆるものを少しずつ",
            "shortLabel": "すべて",
            "description": "一般的なコンピューターユーザーおよびマルチタスクユーザー向け。"
        },
        "filter": "興味の種類でフィルタリング"
    },
    "capabilities": {
        "title": "私のコアAI機能",
        "description": "高度なAIと強力な入力方法を組み合わせることで、アプリやデバイスをシームレスに操作できます。私ができることの一部をご紹介します。",
        "voice_controls": {
            "title": "音声コントロール",
            "description": "自然言語コマンドを理解しているので、あらゆるアプリを音声で制御できます。",
            "longDescription": "自然な話し方で、物事をスムーズに進めることができます。アプリを開いたり、メニューを操作したり、ワークフローを開始したりしたい時、分かりやすい英語をハンズフリーで確実な操作に変換します。"
        },
        "smart_dictation": {
            "title": "インテリジェントなディクテーション",
            "description": "コンテキスト認識とフォーマットを使用して、あなたのスピーチをテキストに変換します。",
            "longDescription": "あなたの言葉を注意深く聞き、正確に捉えます。句読点の追加、大文字の修正、そしてあなたのスタイルに合わせたアレンジをすることで、余分な手間をかけずに洗練された文章に仕上げます。"
        },
        "ai_text_generation": {
            "title": "AIテキスト生成",
            "description": "メール、ドキュメント、コード、クリエイティブなコンテンツを即座に作成できます。",
            "longDescription": "アプリ内で直接、下書き、要約、拡張など、あらゆる作業をサポートします。メールやメモからコードスニペットやドキュメントまで、白紙の状態から始めることなく、スムーズに作成できます。"
        },
        "head_face_controls": {
            "title": "ヘッド＆フェイスコントロール",
            "description": "頭や顔の動きでアクションを起こせるようにします。",
            "longDescription": "あなたの自然な頭の動きや表情を、正確な入力に変換します。笑顔でメールを送信したり、うなずきながらページをめくったり、眉を上げてクリックしたりできます。"
        },
        "natural_language_voice_clicking": {
            "title": "自然言語音声クリック",
            "description": "画面上のボタン、リンク、メニューをクリックするときに、見たものをそのまま発音できるようにします。",
            "longDescription": "画面上の何かの名前を話すと、私がそれを見つけて操作します。コマンドを覚える必要はありません。欲しいものを説明するだけで、クリックは私が行います。"
        },
        "keyboard_mouse_emulation": {
            "title": "キーボードとマウスのエミュレーション",
            "description": "キー、クリック、スクロールをエミュレートするので、ハードウェアなしでアプリを制御できます。",
            "longDescription": "キーストローク、マウスの動き、クリック、スクロールイベントを必要な場所に送信します。音声コントロールやヘッドコントロールと組み合わせることで、従来の入力デバイスを完全に置き換えたり、強化したりすることも可能です。"
        },
        "profiles_personalization": {
            "title": "パーソナライゼーション",
            "description": "あなたの好みを記憶し、保存されたアプリのコントロールに適応します。",
            "longDescription": "お気に入りのアプリ、コマンド、設定を常に記録します。アプリのコントロールを自動または手動で切り替えると、常にあなたの作業に最適なコントロールが表示されます。"
        },
        "cross_device_connectivity": {
            "title": "クロスデバイス接続",
            "description": "携帯電話を使ってコンピューターを制御できるようにします。",
            "longDescription": "モバイルデバイスをデスクトップに接続すれば、コマンドの起動、音声入力、ナビゲーションが簡単に行えます。プレゼンテーション、リモートセッション、または普段使いに最適です。"
        },
        "quick_action_buttons": {
            "title": "クイックアクションボタン",
            "description": "素早いアクションのためにアプリ対応ボタンを用意しました。",
            "longDescription": "アプリに合わせて状況に応じたボタンを配置します。会議への参加、メッセージの送信、メールの新規作成など、複雑なタスクもワンクリックで実行できます。"
        },
        "ai_app_awareness": {
            "title": "AIアプリ認識",
            "description": "使用しているアプリに応じてコントロールを調整します。",
            "longDescription": "画面上で何がアクティブになっているかに注意を払い、適切なタイミングで適切な操作を提供します。煩雑さや推測は一切なく、必要な時に必要なものだけを操作できます。すべてデバイス上で実行され、クラウドにデータを送信することはありません。"
        },
        "ai_rewrite": {
            "title": "AIによる書き換え",
            "description": "テキストを書き直して、トーンを改善したり、フォーマットを更新したり、詳細を拡張したりできます。",
            "longDescription": "作業中のテキストをその場で編集します。より親しみやすく、よりフォーマルに、より短く、より長く、より詳細になど、お客様のご要望に合わせて、より効果的に伝えます。"
        },
        "ai_translation": {
            "title": "AI翻訳",
            "description": "言語間、さらにはプログラミング言語間の翻訳も可能です。",
            "longDescription": "テキストを別の音声言語に変換したり、コードを別のプログラミング言語に変換したりできます。作業は現場で行いますので、現在使用しているアプリを離れる必要はありません。"
        },
        "head_mouse": {
            "title": "ヘッドマウス",
            "description": "頭の動きに合わせてマウスカーソルを移動させます。",
            "longDescription": "頭の動きをスムーズにカーソルへ変換します。グライド機能や感度調整機能などにより、正確で快適なハンズフリー操作を実現します。"
        },
        "head_joystick": {
            "title": "ヘッドジョイスティック",
            "description": "ゲームやアプリのジョイスティックとして頭を使えるようにします。",
            "longDescription": "あなたの頭の動きをジョイスティックの軸にマッピングすることで、ハードウェアを使わずにゲームをプレイしたり、クリエイティブなソフトウェアを操作したりできるようになります。あなたの自然な動きを、私がアナログ入力に変換します。"
        },
        "mcp_agent": {
            "title": "MCPエージェント",
            "description": "モデルコンテキストプロトコル (MCP) を介して外部 AI エージェントに接続できます。",
            "longDescription": "私はモデルコンテキストプロトコルを話し、他のAIエージェントやツールと連携して作業できます。つまり、タスクを調整し、コンテキストを交換し、専用の外部システムと連携して能力を拡張できるのです。しかも、すべてユーザーが制御できます。"
        },
        "byo_ai_integration": {
            "title": "独自のAIを導入する",
            "description": "既存の AI を、独自の AI モデルやサービスで強化して、一緒に使用できるようにします。",
            "longDescription": "すでに信頼できるAIサービス、モデル、またはプロバイダーをお持ちの場合は、それらをワークフローに統合できます。生成、書き換え、翻訳に使用するエンジンは、クラウド、ローカル、カスタムなど、柔軟にお選びいただけます。オフラインの場合やサービスが利用できない場合は、組み込みの機能にフォールバックできます。"
        },
        "workflows": {
            "title": "ワークフロー",
            "description": "アクションを繰り返し可能なワークフローに連結するお手伝いをします。",
            "longDescription": "さまざまな入力、コマンド、出力を連携させる複数ステップのプロセスを設計・実行できます。ワークフローを使えば、定型的なタスクを自動化したり、音声やジェスチャーでトリガーされる複雑なインタラクションを作成したりできます。面倒な作業は私が代わりに行います。"
        },
        "showMore": "もっと見る",
        "showLess": "表示を減らす"
    },
    "listing": {
        "title": "ユースケース",
        "titleLong": "私がどのようにお手伝いできるかをご覧ください",
        "recommended": "あなたにおすすめ",
        "exploreMore": "その他のユースケースを見る",
        "description": "ワークフローを強化するために私ができることをすべてご紹介します。生産性の向上からクリエイティブなサポートまで、お客様のニーズに合わせた最適なユースケースを見つけてください。",
        "all": "全て",
        "search": "ユースケース、アプリ、または機能を検索...",
        "noResults": "結果が見つかりませんでした。検索条件またはフィルターを調整してください。",
        "emptyAction": "オンラインでさらに見る"
    },
    "examples": {
        "universalAppControl": {
            "title": "ユニバーサルアプリコントロール",
            "description": "音声コマンドとスマートオートメーションでコンピューター上のあらゆるアプリケーションを制御できます",
            "descriptionLong": "強力な音声コマンドとインテリジェントな自動化機能で、あらゆるアプリケーションを自在にコントロールできます。ユニバーサルアプリコントロールシステムは、ユーザーの作業方法を学習し、ニーズに合わせて適応することで、複雑なタスクをシンプルに、定型的な操作を瞬時に実行します。生産性向上スイートの管理からメディアやゲームアプリケーションの操作まで、この機能はデジタル環境全体で利用できます。"
        },
        "handsFreeComputerControl": {
            "title": "ハンズフリーコンピュータ制御",
            "description": "アクセシビリティのために、頭の動き、音声、視線追跡を使用した完全なコンピューター制御",
            "descriptionLong": "ハンズフリーコントロールシステムで、コンピュータのアクセシビリティを新たな次元へと引き上げます。高度な視線追跡、高精度な頭部動作検出、そして音声コマンドを組み合わせることで、誰でも手を使わずにコンピュータを完全に操作できます。運動障害のある方、マルチタスクを行う方、そしてコンピュータを新しい方法で使いたい方に最適です。"
        },
        "replyToSocialMediaPosts": {
            "title": "ディクテーションでソーシャルメディアへの投稿と返信を高速化",
            "description": "インテリジェントなディクテーションを使用して、あらゆるソーシャル メディアの投稿に返信し、すばやく応答できます。",
            "descriptionLong": "Cephableのインテリジェントなディクテーション機能を使えば、音声入力でソーシャルメディアへの投稿やコメントがさらにスピーディーになります。ディクテーションはあらゆるテキストボックスや投稿欄で使用できるため、ソーシャルメディアに時間を取られることなく、アクティブに過ごすことができます。"
        },
        "clinicalNoteTaking": {
            "title": "臨床医のためのHIPAA準拠のディクテーションとフォーマット",
            "description": "インテリジェントな音声コントロールとディクテーション機能を使って、セッションの合間に臨床メモを取り、時間を節約しましょう。メモはSOAP形式で自動フォーマットされます。",
            "descriptionLong": "HIPAA準拠のディクテーションソフトウェアをお探しですか？Cephableは、インテリジェントな音声コントロールと自動フォーマット機能により、臨床医が患者の記録を迅速に記録できるよう支援します。SOAPメモ、進捗レポート、ログなど、すべてハンズフリーで作成できます。",
            "upgrade": {
                "description": "アップグレードすると、自動フォーマットと反復処理を実行する HIPAA 準拠のオフライン インテリジェント タスクにアクセスできます。"
            }
        },
        "vibeCoding": {
            "title": "思考からコードへ: 開発者とVibe Coderのためのディクテーション",
            "description": "ディクテーションと AI テキスト生成機能を備えた Vibe Code で、定型コードとプロトタイプをより速く記述できます。",
            "descriptionLong": "Cephable Dictationは、開発者が思考からコードへとより速く移行するのに役立ちます。このデモでは、Vercel V0、VS CodeのGitHub Copilot、Base 44、Lovableなどのツール内で、音声コマンドを使ってコンポーネントやダッシュボードなどを生成する方法を紹介します。アイデアを音声で伝え、コードで洗練させましょう。",
            "upgrade": {
                "description": "アップグレードすると、アプリ内コードの書き換え、生成、翻訳のためのオフライン インテリジェント タスクにアクセスできます。"
            }
        },
        "controllingBackgroundMusic": {
            "title": "メディアコントロール: 作業の流れを中断することなく、音楽、ビデオなどを管理できます",
            "description": "現在のタスクに集中しながら、音声コントロールとクイックアクションを使用してバックグラウンド ミュージックを管理します。",
            "descriptionLong": "セファブル音声コマンドを使えば、Spotifyの再生、一時停止、スキップ、音量調節がハンズフリーで簡単に行えます。クイックアクションボタンとすぐに使えるコントロールは、Apple Music、YouTube、Netflixなど、200以上のアプリでも使えます。"
        },
        "editingVideos": {
            "title": "音声を使ったビデオ編集",
            "description": "音声コントロールを使用して、ナビゲート、カット、編集を高速化し、ビデオ編集ワークフローを改善します。",
            "descriptionLong": "クリックではなく、ストーリーに集中しましょう。セファラブル音声コントロールで、Clipchamp、Adobe、iMovie、DaVinci Resolveなど、使い慣れたツールでのビデオ編集を効率化。よりスピーディーに、より少ない手順で編集できます。"
        },
        "inboxTriage": {
            "title": "AIメールアシスタント：自動化、下書き、返信を高速化",
            "description": "音声コントロールとデバイス上の AI テキスト生成を使用して受信トレイを管理し、メールの選別、作成、編集を行います。",
            "descriptionLong": "プライベートなオンデバイスAIでメール処理をスピードアップ。Cephableは音声コマンド、ディクテーション、クイックアクションボタン、テキスト生成を組み合わせ、受信トレイの管理をより迅速かつ簡単にします。Outlook、Gmailなどで、メールの削除、返信の下書き、クリエイティブな返信の作成をハンズフリーで行えます。",
            "upgrade": {
                "description": "アップグレードすると、自動フォーマット、コンテンツ生成、翻訳などを行うオフライン インテリジェント タスクにアクセスできます。"
            }
        },
        "summarizingReports": {
            "title": "プライベートなデバイス内 AI で機密レポートを要約",
            "description": "AI テキスト生成を使用して、プライベートを保ちながらデバイス上で長いレポートをチームに要約します。",
            "descriptionLong": "デバイス上のAIを活用して、長文のレポートを分かりやすいチームアップデートに変換します。Cephableは重要なポイントと数値を抽出し、簡潔な要約を生成してチームと直接共有できます。すべての処理はデバイス上で行われるため、機密データは安全に保たれます。"
        },
        "handsFreeMeeting": {
            "title": "ハンズフリーコントロールで会議の疲労を軽減",
            "description": "音声コマンド、クイック アクション ボタン、スマート ディクテーションを使用してビデオ会議を制御します。",
            "descriptionLong": "メニューをクリックすることなく、会議に集中できます。Cephable は、Microsoft Teams、Zoom、Google Meet などのデバイスに音声コマンドとクイックアクションボタンを提供します。ミュート/ミュート解除、ビデオのオン/オフ、チャットメッセージの送信、挙手、会議ウィンドウの操作など、すぐに使えるコントロールをワークフローに合わせてカスタマイズし、ハンズフリーで操作できます。"
        },
        "spreadsheetReviews": {
            "title": "音声コントロールと AI 自動化でスプレッドシートでの作業をスピードアップ",
            "description": "ナビゲーション、書式設定、フィルタリング、編集用の音声コントロールを使用して、大規模なスプレッドシートをすばやく確認および編集します。",
            "descriptionLong": "Cephableは、Excel、Googleスプレッドシート、その他のスプレッドシートツールに音声コントロールとクイックアクションボタンを提供します。レビュー、編集、コメントの追加、マクロやショートカットの起動、ワークフローに合わせたコマンドのカスタマイズなど、様々な機能が利用可能です。数百種類のコントロールは、すぐに使えるものもあれば、設定に合わせてカスタマイズできるものもあります。"
        },
        "socialMediaWriting": {
            "title": "プライベートなデバイス内AIによるコンテンツ作成とリサーチ",
            "description": "音声コントロールと AI テキスト生成を使用して、魅力的なコンテンツを作成するためのソーシャル メディア投稿の下書きと書き込みを行います。",
            "descriptionLong": "Cephableのデバイス内AIで安全にコンテンツを作成。クラウドは不要です。お気に入りのツール内で、ソーシャルメディアの投稿、メール、キャッチフレーズ、ドキュメントを瞬時に生成・書き換えできます。すべてローカルで実行されるため、機密性の高いコンテンツのプライバシーは確保され、どこからでも作業できます。"
        },
        "fpsGamePlay": {
            "title": "音声コントロールでFPSゲームをプレイ",
            "description": "移動、照準、射撃を音声コントロールで操作し、一人称シューティング ゲームをプレイしてカスタマイズします。",
            "descriptionLong": "音声コントロールで、一人称視点シューティングゲームを新たな方法でプレイしましょう。音声操作で移動、照準、射撃を操作し、より没入感のあるハンズフリーのゲーム体験を実現します。"
        },
        "customizingGameControls": {
            "title": "RPGゲームコントロールのカスタマイズ",
            "description": "ロール プレイ ゲームのコントロールをカスタマイズして、アクセシビリティとゲーム プレイを向上させます。",
            "descriptionLong": "カスタマイズ可能なコントロールで、アクセシビリティとゲームプレイを向上させ、自分だけのゲーム体験を。好みやプレイスタイルに合わせて設定を調整し、快適で楽しいゲームセッションを実現しましょう。"
        },
        "webBrowsing": {
            "title": "CephableでハンズフリーWebブラウジング | 旅行の計画、オンラインショッピングなど",
            "description": "音声コントロールを使用して、ハンズフリーで Web を閲覧し、ナビゲート、スクロール、フォームへの入力を行うことができます。",
            "descriptionLong": "入力なしで検索、ショッピング、プランニング。Cephableのインテリジェントな音声コントロールは、どのブラウザでも使えます。航空券の予約、オンラインショッピング、次の旅行のリサーチなど、あらゆる場面で活躍します。"
        },
        "documentCode": {
            "title": "デバイス上の AI テキスト生成による高速で安全なコードドキュメント",
            "description": "Cephable のインテリジェント リライトを使用して、同じアプリ内で機密データをクラウドに送信せずにコードを文書化します。",
            "descriptionLong": "Cephableのインテリジェントリライト機能は、機密データをクラウドに送信することなく、コードから直接開発者向けドキュメントを作成します。READMEファイル、Markdownドキュメント、APIリファレンスをすべてアプリ内で迅速かつ安全に生成します。"
        },
        "generateCode": {
            "title": "デバイス上の AI テキスト生成による高速で安全なコード生成",
            "description": "AI インテリジェント タスクを使用して、チケット要件からコード スニペットのプロトタイプを作成します。",
            "descriptionLong": "Cephableを使えば、チケットの要件をあらゆる言語で動作するコードに変換できます。インテリジェントタスクを使えば、コードのスキャフォールディング、ドキュメント生成、ユニットテストの追加を自動化できます。コンテキストを失うことなく、複数のプログラミング言語やアプリで作業できます。"
        },
        "editingImages": {
            "title": "音声コントロールとディクテーションでクリエイティブアプリの編集を高速化",
            "description": "音声コントロールと AI テキスト生成を使用して画像を作成および編集し、すばやく調整してコンセプトを作成します。",
            "descriptionLong": "音声制御による画像作成・編集で、あなたのビジュアルアイデアを現実に。AIテキスト生成機能を使えば、複雑なメニューを操作することなく、素早く調整したり、コンセプトを生成したり、画像の魅力を高めたりできます。"
        },
        "requirementDocsFromMeeting": {
            "title": "オンデバイス AI を活用し、メモから製品要件ドキュメントまでを数分で作成",
            "description": "生の会議記録を数分で構造化された製品要件ドキュメントに変換することで、時間を節約できます。",
            "descriptionLong": "Cephableは、インテリジェントタスクを活用して、生の会議記録をわずか数分で構造化された製品要件ドキュメントに変換します。製品、マーケティング、ユーザーニーズを迅速に把握し、デバイス上のAIによって機密性の高い議論を非公開に保ちます。結果を新しいドキュメントとして即座に保存できます。"
        },
        "gamingVoiceControls": {
            "title": "WoW の音声コントロール | メニュー、PvP、ダンジョンファインダーのクイックナビゲーション",
            "description": "音声コマンドを使用してゲームプレイを制御し、メニューを移動したり、PvP バトルを開始したり、ダンジョンを見つけたりします。",
            "descriptionLong": "音声操作による操作で、ゲーム体験をさらに充実させましょう。シンプルな音声コマンドでメニューの操作、PvPバトルの開始、ダンジョンの探索などが可能になり、ゲームプレイに集中しながらも、操作性を維持できます。"
        },
        "headMouseMovement": {
            "title": "ヘッドマウスを使ったハンズフリーゲーミングセットアップ",
            "description": "頭の動きでマウス カーソルを制御し、正確なナビゲーションとクリックを実現します。",
            "descriptionLong": "ヘッドマウスコントロールでハンズフリーゲームを実現。頭を傾けたり回したりしてカーソルを動かし、速度と感度をカスタマイズして、従来のマウスを使わずに操作できます。"
        },
        "noteTakingAndDocumentation": {
            "title": "プライベートなデバイス内 AI を使用したメモ作成とドキュメント生成",
            "description": "音声コントロールと AI テキスト生成を使用してメモを取り、ドキュメントを生成し、効率的に書き込みます。",
            "descriptionLong": "インテリジェントなディクテーションとAIを活用したドキュメント生成で、メモ作成を効率化。下書き、アウトライン、そして洗練されたドキュメントを素早く作成できるので、書式設定に煩わされることなくアイデアに集中できます。すべての処理はデバイス上で行われるため、プライバシーとセキュリティが確保されます。",
            "upgrade": {
                "description": "アップグレードすると、書式設定、コンテンツの反復処理などを行うオフライン インテリジェント タスクにアクセスできます。"
            }
        },
        "presentationControls": {
            "title": "音声コマンドとクイックアクションによるハンズフリープレゼンテーションコントロール",
            "description": "音声コマンドを使用してプレゼンテーションを制御し、スライド間を移動したり、プレゼンテーションを開始/停止したり、ポイントを強調表示したりできます。",
            "descriptionLong": "音声コマンドを使って、自信を持ってプレゼンテーションを行うことができます。スライドの移動、プレゼンテーションの開始と停止、重要なポイントの強調表示など、すべてコンピューターに触れることなく行えます。"
        },
        "designingFliers": {
            "title": "クリエイティブアプリでデザインする",
            "description": "音声コントロールとスマートディクテーションを使用してデザインを作成および編集し、反復作業を高速化します。",
            "descriptionLong": "音声操作のデザインツールで、クリエイティブなビジョンを現実に。複雑なメニューに迷うことなく、デザインをスムーズに操作、編集、修正できるので、クリック操作ではなく、創造性そのものに集中できます。"
        },
        "motionDesign": {
            "title": "モーションデザインとアニメーションのための音声コマンド",
            "description": "直感的な音声コマンドを使用してシーンをアニメートし、キーフレームを制御し、シームレスなモーション デザインを実現します。",
            "descriptionLong": "音声駆動型アニメーションツールで、アイデアに動きを加えましょう。タイムライン、キーフレーム、エフェクトを自然言語で簡単に操作できるので、複雑なインターフェースに煩わされることなく、ストーリーテリングと視覚的なリズムに集中できます。"
        }
    }
}
